import { render, staticRenderFns } from "./printTip.vue?vue&type=template&id=2584513a&scoped=true&"
import script from "./printTip.vue?vue&type=script&lang=js&"
export * from "./printTip.vue?vue&type=script&lang=js&"
import style0 from "./printTip.vue?vue&type=style&index=0&id=2584513a&lang=sass&scoped=true&"
import style1 from "./printTip.vue?vue&type=style&index=1&id=2584513a&lang=sass&scoped=true&"
import style2 from "./printTip.vue?vue&type=style&index=2&id=2584513a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.8.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2584513a",
  null
  
)

export default component.exports